jQuery(document).ready(function ($) {
    var $slider = $(".fp-slider")
    .on("init", function(slick) {
      $(".fp-slider").addClass('ready');
    })
    .slick({
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        'prevArrow': $('.prev-arrow'),
        'nextArrow': $('.next-arrow'),
    });

    var $slider2 = $(".contact-person-slider");
    if ( $( $slider2 ).length ) {
        $slider2.on("init", function(slick) {
            $slider2.addClass('ready');
        })
        .slick({
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            'prevArrow': $('.prev-arrow'),
            'nextArrow': $('.next-arrow'),
            responsive: [
                {
                  breakpoint: 768,
                  settings: {

                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                  }
                }
              ]
        });
    }
});